import { actionTypes as resourceActions } from "../reducers/resources";

export const selectCategory = (category) => {
	const action = {
		type: resourceActions.SORT_TYPE,
		category,
	};
	return action;
};
